export const LFincCriterioDiaUtil = [
  { key: 0, text: "0 - Nenhum" },
  { key: 1, text: "1 - Vencimento no próximo dia útil" },
  { key: 2, text: "2 - Vencimento no dia útil anterior" },
];
